<template lang="jade" src="../_partials/button.jade"></template>
<script>
  import _ from 'lodash'
  import { recursiveObjSearch } from 'src/utils/util'
  import buttons from '../_shared/traits'
  import { Workflows } from 'src/services/resources'

  export default{
    data () {
      return {}
    },
    mixins: [buttons],
    methods: {
      click () {
        this.escape()
        // this.submit()
      },
      /**
       * Delete the dynamic workflow both from the dom and the index
       */
      deleteDynamicWorkflows () {
        if (recursiveObjSearch('uid', this.uid, this.dynamicWorkflows) !== null) {
          document.getElementById(this.uid).parentNode.removeChild(document.getElementById(this.uid))
          this.removeDynamicWorkflow(_.findIndex(this.dynamicWorkflows, {'uid': this.uid}))
        }
      },
      /**
       * Escape button press.
       * Basically a back button, extract the last call form the history state
       * and replicate it.
       */
      escape () {
        this.proccessing = true
        this.$dispatch('form::submitted')
        Workflows.escape({button: this.fdata.buttonId}, this.headers)
          .then(this.success)
          .catch(this.failed)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// escape.vue?c8557fae